__turbopack_context__.v({
  "column": "Ewfi0a_column",
  "row": "Ewfi0a_row",
  "separator": "Ewfi0a_separator",
  "subTotalText": "Ewfi0a_subTotalText",
  "subTotalValue": "Ewfi0a_subTotalValue",
  "totalContainer": "Ewfi0a_totalContainer",
  "totalText": "Ewfi0a_totalText",
  "totalValue": "Ewfi0a_totalValue",
  "vatIncludedText": "Ewfi0a_vatIncludedText",
});
